<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :items="civilites"
    item-value="id"
    :data-testid="dataTestid"
  />
</template>

<script>
import civilite from "@/filters/civilite";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      civilites: ["M", "MME"].map(id => ({ id, text: civilite(id) })),
    };
  },
};
</script>
